import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Modal = ({ isOpen, onClose, title, children }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm"
          onClick={onClose} // click outside closes
        >
         <motion.div
  initial={{ opacity: 0, scale: 0.9, y: -20 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  exit={{ opacity: 0, scale: 0.9, y: -20 }}
  transition={{ duration: 0.2, ease: "easeOut" }}
  className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl h-[60vh] overflow-y-auto"
  onClick={(e) => e.stopPropagation()}
>
  {/* Header */}
  <div className="flex items-center justify-between px-5 py-3 border-b bg-gradient-to-r from-blue-500 to-indigo-600">
    <h2 className="text-lg font-semibold text-white">{title}</h2>
    <button
      onClick={onClose}
      className="text-white hover:text-gray-200 text-xl"
    >
      ✕
    </button>
  </div>

  {/* Content */}
  <div className="p-5">{children}</div>
</motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
